import { createClient, createFetchAdapter } from 'ts-procedures/client';
import { createDownloadsApiBindings } from './generated';
export * as Client from './generated/_client';
export * as Types from './generated/_types';
export { DownloadsApi } from './generated/index';
export function makeClient(opts) {
    return createClient({
        adapter: createFetchAdapter(),
        basePath: opts.basePath,
        hooks: {
            ...opts.hooks,
            onBeforeRequest(ctx) {
                const addtl = {
                    'x-authtoken': opts.headers?.authToken ?? '',
                    'x-regionids': opts.headers?.regionIds?.join(',') ?? '',
                };
                ctx.request.headers = {
                    ...ctx.request.headers,
                    ...addtl,
                };
                if (opts.hooks?.onBeforeRequest) {
                    return opts.hooks.onBeforeRequest(ctx);
                }
                return ctx;
            },
        },
        scopes: createDownloadsApiBindings,
    });
}
//# sourceMappingURL=index.js.map